import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const API_BASE_URL = process.env.REACT_APP_API_URL;

function EditTeam() {
  const { id } = useParams(); // pulls :id from URL
  const [teamName, setTeamName] = useState('');
  // const [team, setTeam] = useState(null); // Unused for now
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [availableAgents, setAvailableAgents] = useState([]);
  const [selectedAgents, setSelectedAgents] = useState([]);
  const [, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  // Load team data
  useEffect(() => {
    const loadTeamData = async () => {
      console.log('Loading team data ', API_BASE_URL);
      try {
        // Fetch team + members
        const teamRes = await fetch(`${API_BASE_URL}/teams/${id}`);
        const teamData = await teamRes.json();
        console.log('Team data', teamData);
        setTeamName(teamData.team.name);
        setSelectedAgents(teamData.members);
        // setTeam(teamData.team); // Unused for now
        setSelectedMembers(teamData.members);

        // Fetch available users
        const usersRes = await fetch(`${API_BASE_URL}/users`);
        const usersData = await usersRes.json();
        console.log('Users data', usersData);

        // Remove users already selected
        const selectedIds = new Set(teamData.members.map(m => m.id));
        const available = usersData.filter(u => !selectedIds.has(u.id));

        setAvailableAgents(available);
      } catch (err) {
        console.error('Failed to load team data:', err);
      } finally {
        setLoading(false);
      }
    };

    loadTeamData();

  }, [id]);

  const addSelected = (selectedIds) => {
    const selected = availableAgents.filter(a => selectedIds.includes(a.id));
    setAvailableAgents(availableAgents.filter(a => !selectedIds.includes(a.id)));
    setSelectedAgents([...selectedAgents, ...selected]);
  };

  const removeMember = (id) => {
    const removed = selectedAgents.find(a => a.id === id);
    if (removed) {
      setAvailableAgents([...availableAgents, removed]);
      setSelectedAgents(selectedAgents.filter(a => a.id !== id));
    }
  };

  const handleSave = () => {
    if (selectedAgents.length === 0) {
      alert('You must select at least one team member.');
      return;
    }

    const payload = {
      teamName,
      members: selectedAgents.map(a => ({
        ownerId: a.id,
        userId: a.userId,
        first_name: a.firstName,
        last_name: a.lastName,
      })),
    };

    setSaving(true);

    // Send to backend
    console.log('Saving team:', payload);
    // simulate API call
    setTimeout(() => {
      setSaving(false);
      alert('Team saved!');
    }, 1000);
  };

  return (
    <div style={{ padding: '2rem' }}>
      <h3>Edit Team</h3>
      <p>Add or remove team members or rename your team.</p>

      <label htmlFor="teamName">Team Name:</label>
      <input
        id="teamName"
        value={teamName}
        onChange={(e) => setTeamName(e.target.value)}
        required
        style={{ marginBottom: '1rem', display: 'block' }}
      />

      <div style={{ display: 'flex', gap: '2rem' }}>
        {/* Available agents */}
        <div style={{ flex: 1 }}>
          <h4>Available Team Members</h4>
          <select multiple size="10" id="agent-select" style={{ width: '100%' }}>
            {availableAgents.map(agent => (
              <option key={agent.id} value={agent.id}>
                {agent.firstName} {agent.lastName}
              </option>
            ))}
          </select>
          <br />
          <button
            onClick={() => {
              const selectedOptions = Array.from(document.getElementById('agent-select').selectedOptions);
              const selectedIds = selectedOptions.map(o => parseInt(o.value));
              addSelected(selectedIds);
            }}
            style={{ marginTop: '0.5rem' }}
          >
            Add Selected
          </button>
        </div>

        {/* Selected agents */}
        <div style={{ flex: 1 }}>
          <h4>Selected Team Members</h4>
          <ul id="selected-owners">
            {selectedMembers.map((member) => (
              <li key={member.id}>
                {member.first_name} {member.last_name}
                <button
                  onClick={() => removeMember(member.id)}
                  style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    paddingLeft: '8px',
                  }}
                  aria-label={`Remove ${member.first_name} ${member.last_name}`}
                >
                  <i className="far fa-trash-alt" />
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <br />

      <button onClick={handleSave} disabled={saving}>
        {saving ? 'Saving...' : 'Save Team'}
      </button>
    </div>
  );
}

export default EditTeam;
